import React from 'react';

const FaqPage = () => {
  return <h1>FaqPage</h1>;
};

export default FaqPage;
